import type { BaseSystemRepository } from "./BaseSystemRepository.interface";
import { storedLocalApiPort } from "../../../lib/localApi";

let PrivateInstance: ApiSystemRepository | null = null;
class ApiSystemRepository implements BaseSystemRepository {
  private Domain = "http://localhost";
  Port?: number;
  private initializationPromise!: Promise<void>;

  constructor() {
    if (PrivateInstance) {
      return PrivateInstance;
    }

    this.initializationPromise = this.initialize();
  }

  private async initialize() {
    const port = storedLocalApiPort();
    if (port) {
      this.Port = port;
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      PrivateInstance = this;
    }
  }

  async keepAlive(port?: number) {
    await this.initializationPromise;
    if (!(port || this.Port)) return false;

    try {
      const response = await fetch(`${this.Domain}:${port || this.Port}/health`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      await response.text();
      return response.status === 200;
    } catch {
      return false;
    }
  }
}

export default ApiSystemRepository;
